<!-- <template>
<div class="sidebar">
  <div class="header">
    <span class="material-icons">menu</span>
    <img class="header-logo" src="../../../public/logos/CartagoFull.png" alt="logo">
  </div>
  <Contact />
</div>
<div class="contentDesktop" v-dragscroll.y="true">
  <div class="searchbar">
    <span class="material-icons">search</span><span>Search mail</span>
  </div>
  <div class="mail">
    <div class="text">
      <div class="sender">
        <img class="senderImg" src="../../../public/logos/Cartago.png" alt="senderImg">
      </div>  
    <h2 class="mailtext">Your new automated Mail<br> 
    <span class="absender">&lt;example@cartago.com&gt;</span></h2>
  </div>
  <div class="icons">
    <span class="material-icons">keyboard_double_arrow_right</span>
    <span class="material-icons">more_vert</span>
  </div>
  </div>
  <div class="container">
    <div class="iframeLayer"></div> 
    <div class="templateHtml" style="z-index: 4; position: relative;">
    <Preview/>
    </div>
  </div>
</div>
</template>

<script>
import Contact from './previewProps/Contact.vue'
import {dragscroll} from 'vue-dragscroll'
import Preview from '../Preview.vue'
export default {
  directives: {dragscroll},
  components: {Contact, Preview}

}
</script>

<style scoped>
.container{
  position: relative;
  width:100%;
}
.iframeLayer{
  top: 0;
  left:0;
  width:100%;
  height: 100%;
  opacity: 0;
  z-index: 30;
  position: absolute;
}
.iFrame {
        width: 100%;
        min-height: 100vh;
      }
.material-icons{
        font-size: 35px;

    }
    .sidebar{
      width: 22%;
      justify-content: center;
      float:left;
    }

    .header{
    display:flex;
    margin-left: 40px;
      margin-top: 30px;
      margin-bottom: 30px;
    }

    .header-logo{
      width: 200px;
      margin-left: 20px;
    }

    .contentDesktop{
      width: 78%;
      overflow-y: scroll;
      overflow-x: hidden;
      
    }

    .searchbar{
      padding: 8px;
      font-size: 20px;
      margin-top: 15px;
      margin-bottom: 10px;
      display: flex;
      justify-content: start;
      align-items: center;
      width: 60%;
      border: solid black;
      background-color: lightgray;
      border-radius: 15px;
    }

    .mail{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .sender{
    border-radius: 50%;
    border: black solid;
    background: lightgrey;
    margin-right: 10px;
    width: 50px;
    }

    .senderImg{
      width: 30px;
      margin: 8px;
    }
    .text{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    
    
</style> -->
<template>
  <div class="sidebar" :class=" {invert: colorMode == 'dark'}">
    <div class="header">
      <span class="material-icons">menu</span>
      <img class="header-logo" src="../../../public/logos/CartagoFull.png" alt="logo">
    </div>
    <Contact />
  </div>
  <div class="contentDesktop" v-dragscroll.y="true" :class=" {invert: colorMode == 'dark'}">
    <div class="searchbar">
      <span class="material-icons">search</span><span>Search mail</span>
    </div>
    <div class="mail">
      <div class="text">
        <div class="sender">
          <img class="senderImg" src="../../../public/logos/Cartago.png" alt="senderImg">
        </div>  
        <h2 class="mailtext">Your new automated Mail<br> 
        <span class="absender">&lt;example@cartago.com&gt;</span></h2>
      </div>
      <div class="icons">
        <span class="material-icons">keyboard_double_arrow_right</span>
        <span class="material-icons">more_vert</span>
      </div>
    </div>
    <div class="container">
      <div class="iframeLayer"></div>
      <div class="templateHtml" style="z-index: 4; position: relative;">
        <iframe 
          class="iFrame" 
          :srcdoc="iframeContent" 
          frameborder="0"
          scrolling="no"
          @load="adjustIframeHeight"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from './previewProps/Contact.vue';
import { dragscroll } from 'vue-dragscroll';
import { mapGetters, mapState } from 'vuex';
import { convertJsonToHtml } from '@/utils/convertJsonToHtml';
import { generateSrcDoc} from '@/utils/generateSrcDoc';

export default {
  directives: { dragscroll },
  components: { Contact },
  computed: {
    ...mapGetters(['getEmailData']),
    ...mapState(['colorMode']),
    iframeContent() {
      //return convertJsonToHtml(this.getEmailData);
      const htmlContent = convertJsonToHtml(this.getEmailData, true)
      return generateSrcDoc (htmlContent, this.colorMode) 
    }
  },
  methods: {
    adjustIframeHeight(event) {
      const iframe = event.target;
      iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
}

.iframeLayer {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 30;
  position: absolute;
}

.iFrame {
  width: 100%;
  min-height: 100vh;
}

.material-icons {
  font-size: 35px;
}

.sidebar {
  width: 22%;
  justify-content: center;
  float: left;
}

.header {
  display: flex;
  margin-left: 40px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.header-logo {
  width: 200px;
  margin-left: 20px;
}

.contentDesktop {
  width: 78%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.searchbar {
  padding: 8px;
  font-size: 20px;
  margin-top: 15px;
  margin-bottom: 10px;
  display: flex;
  justify-content: start;
  align-items: center;
  width: 60%;
  border: solid black;
  background-color: lightgray;
  border-radius: 15px;
}

.mail {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sender {
  border-radius: 50%;
  border: black solid;
  background: lightgrey;
  margin-right: 10px;
  width: 50px;
}

.senderImg {
  width: 30px;
  margin: 8px;
}

.text {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.invert {
  background: rgb(43, 43, 43);
  color: white;
}

.invert img{
  -webkit-filter: drop-shadow(1px 1px 0 white)
                  drop-shadow(-1px -1px 0 white);
  filter: drop-shadow(1px 1px 0 white) 
          drop-shadow(-1px -1px 0 white);
}

.invert {
  background: rgb(43, 43, 43);
  color: white;
}

.invert img{
  -webkit-filter: drop-shadow(1px 1px 0 white)
                  drop-shadow(-1px -1px 0 white);
  filter: drop-shadow(1px 1px 0 white) 
          drop-shadow(-1px -1px 0 white);
}

</style>
